<div class="mt-3 side-menu-back">
  <app-side-menu-doetam-button *ngFor="let item of ctx.ShopModuleMenu.MenuItems" [menuItem]="item" [parentMenu]="ctx.ShopModuleMenu.MenuItems" [btnClass]="'btn-warning'"></app-side-menu-doetam-button>
</div>
